// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://test.superlawyer.in/wp-json/wp/v2/',
  baseUrl2:'https://test.superlawyer.in/wp-json/custom-api/v1/',
  youtubeApiUrl: 'https://test.superlawyer.in/wp-json/custom/v1/',
  secrateKey: 'cd9a7a4d-a9d1-4a10-9875-39ba4691783a',
  returnUrl: '',
  // Frontend URL for meta tags
  frontendUrl: 'https://superlawyer-ui-development.lawsikho.dev',

   // SuperLawyer team page URL
   teamUrl: 'https://superlawyer.in/about-us/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
